import React from 'react';
import { MobileAppearance } from '../AppearanceComponents/Mobile';
import PluginSlot from '../PluginSlot';
export default function Mobile(_ref) {
  var _innerRef$current;
  var editorView = _ref.editorView,
    maxHeight = _ref.maxHeight,
    persistScrollGutter = _ref.persistScrollGutter,
    editorDOMElement = _ref.editorDOMElement,
    disabled = _ref.disabled,
    contentComponents = _ref.contentComponents,
    editorActions = _ref.editorActions,
    eventDispatcher = _ref.eventDispatcher,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    providerFactory = _ref.providerFactory,
    appearance = _ref.appearance,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    innerRef = _ref.innerRef,
    pluginHooks = _ref.pluginHooks,
    featureFlags = _ref.featureFlags;
  return /*#__PURE__*/React.createElement(MobileAppearance, {
    ref: innerRef,
    editorView: editorView || null,
    maxHeight: maxHeight,
    persistScrollGutter: persistScrollGutter,
    editorDisabled: disabled,
    featureFlags: featureFlags
  }, editorDOMElement, /*#__PURE__*/React.createElement(PluginSlot, {
    editorView: editorView,
    editorActions: editorActions,
    eventDispatcher: eventDispatcher,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    providerFactory: providerFactory,
    appearance: appearance,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    containerElement: (_innerRef$current = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) !== null && _innerRef$current !== void 0 ? _innerRef$current : null,
    disabled: !!disabled,
    wrapperElement: null,
    pluginHooks: pluginHooks
  }));
}